import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { RoleService } from '../services/role.service';
import { RoleInterface } from '../interfaces/role-interface';

@Injectable({
  providedIn: 'root',
})
export class RolesResolver {
  public constructor(private readonly roleService: RoleService) {}

  public resolve(): Observable<ReadonlyArray<RoleInterface>> {
    if (this.roleService.roles && this.roleService.roles.length === 4) {
      return of(this.roleService.roles);
    }

    return this.roleService.getRoles();
  }
}
